<template>
  <div v-loading="isLoading">
    <el-row class="title-bar" type="flex" justify="end">
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row class="gray-box mr-b10" v-show="showSearchTool" type="flex" justify="start">
      <div>
        <span class="tit" >장비명</span>
        <el-input class="mr-r15" style="width: 150px;" v-model="objName" clearable @keyup.enter.native="clickSearchBtn"></el-input>
        <span class="tit">IP</span>
        <el-input v-model="ipaddress" clearable style="width: 150px;" @keyup.enter.native="clickSearchBtn"></el-input>
      </div>
      <el-button class="mr-l4" @click="clickSearchBtn">검색</el-button>
    </el-row>
    <ul class="list list-event" ref="perfList">
      <li v-for="data in perfData" :key="data.objId" :style="{borderColor: data.eventlevelColor}">
        <span>{{ data.objName }}</span>
        <span v-if="!isNil(data.ipaddress)">{{ data.ipaddress }}</span>
        <span v-if="!isNil(data.objtypeName)">{{ data.objtypeName }}</span><span v-else>{{ EMPTY_TEXT }}</span>
        <template v-for="(rscInfo, index) in data.rscInfos">
          <span v-if="data.objtypeId === 'VVM' && index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
            <b>운영 상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
          </span>
          <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
            <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
          </span>
        </template>
      </li>
    </ul>
    <el-row class="mr-t10" type="flex" justify="center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalPerfData">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import keys from 'lodash/keys';
import isNil from 'lodash/isNil';
import { convertValuByUnit, convertValueWithMetricPrefix } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { VMS_OBJTYPE } from '@/constants/objdefine';
import perfApi from '@/api/virtual/performance/common';
import { defaultPagination } from '@/constants/table';
import { mapGetters } from 'vuex';

export default {
  name: 'WAllVirtualPerfList',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      EMPTY_TEXT,
      params: {},
      objName: '',
      ipaddress: '',
      showSearchTool: false,
      perfData: [],
      totalPerfData: 0,
      currentPage: 1,
      pageSize: defaultPagination.pageSize,
      pageSizes: defaultPagination.pageSizes,
      isLoading: false,
    };
  },
  computed: mapGetters(['selectedNode', 'selectedVmsObjtypeIds']),
  watch: {
    selectedNode: {
      handler() {
        this.showSearchTool = false;
        this.objName = '';
        this.ipaddress = '';
        this.loadStore();
      },
    },
    selectedVmsObjtypeIds: {
      handler() {
        this.loadStore();
        // if (this.$refs.perfList === undefined) {
        //   this.$nextTick(() => {
        //     this.loadStore();
        //   });
        // } else {
        //   this.loadStore();
        // }
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    isNil,
    convertValuByUnit,
    getValueAfterCheckEmpty,
    convertValueWithMetricPrefix,
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadStore();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadStore();
    },
    loadStore() {
      if (this.active) {
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        this.params.treeType = treeType;
        this.params.subType = this.selectedNode.subType;
        this.params.managetypeId = this.selectedNode.managetypeId;
        this.params.hypervisorType = this.selectedNode.hypervisorType;
        this.params.objId = this.selectedNode.obj ? this.selectedNode.obj.objId : null;
        this.params.virtualcenterGroupId = this.selectedNode.virtualcenterGroupId;
        this.params.start = (this.currentPage * this.pageSize) - this.pageSize;
        this.params.limit = this.pageSize;
        this.params.objtypeId = this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId;
        this.params.objtypeIds = this.selectedVmsObjtypeIds.length === 0 ? keys(VMS_OBJTYPE) : this.selectedVmsObjtypeIds;
        this.setSearchParams();

        this.isLoading = true;
        perfApi.getVirtualGroupPerformanceInfo(this.params).then((response) => {
          if (response.data.success) {
            this.totalPerfData = response.data.total;
            this.perfData = response.data.data;
          }
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    clickSearchBtn() {
      this.currentPage = 1;
      this.loadStore();
    },
    setSearchParams() {
      const searchParams = [];
      if (this.objName) {
        searchParams.push(
          {
            field: 'objName',
            value: this.objName,
          },
        );
      }
      if (this.ipaddress) {
        searchParams.push(
          {
            field: 'ipaddress',
            value: this.ipaddress,
          },
        );
      }
      this.params.searchParams = searchParams;
    },
    setElementStatusLabel(status) {
      if (isNil(status)) {
        return EMPTY_TEXT;
      } else if (status === '1') {
        return 'UP';
      } else if (status === '0') {
        return 'DOWN';
      }
      return status;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/virtual/performance/group/perfinfo/components/AllVirtualPerfList.vue